import { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { ISearchAddressesInput } from "../../../types/address";
import { Action } from "../../../types/reducer-action";
import { getFormDataObject, isBlank } from "../../../utils/commons";
import BusyButton from "../../common/busy-button";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { RefreshIcon, SearchIcon } from "../../common/icons";
import InlineFeedback from "../../common/inline-feedback";
import CityInput from "../../common/search-input/city-input";
import PostalCodeInput from "../../common/search-input/postal-code-input";
import { useAddressDispatch } from "./address-manager-context";
import './style.scss';
import useAddressApi from "./useAddressApi";
import SpinnerOverlay from "../../common/spinner/spinner";

export default function AddressSearchForm() {
  const dispatch = useAddressDispatch();

  const [invalid, setInvalid] = useState(false);

  const { searchAddresses, busy } = useAddressApi();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const input = getFormDataObject<ISearchAddressesInput>(event.currentTarget);

    const ok = Object.values(input).some(v => !isBlank(v));
    setInvalid(!ok);

    ok && searchAddresses(input);
  };

  const handleReset = () => {
    setInvalid(false);
    dispatch(new Action(DataEntryEvent.NewDataSet));
  };

  return (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="building_filter" sm={4}>Building:</Label>
            <Col sm={6}>
              <Input id="building_filter" name="building" placeholder="Enter a building name"
                maxLength={100} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup row>
            <Label for="address_filter" sm={4}>Street/PO/Rural:</Label>
            <Col sm={6}>
              <Input id="address_filter" name="address" placeholder="Enter a street/PO/Rural"
                maxLength={100} />
            </Col>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="city_filter" sm={4}>Municipality/City:</Label>
            <Col sm={6}>
              <CityInput id="city_filter" name="municipality"
                placeholder="Enter a municipality or city name"
                innerName="municipalityId" />
            </Col>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup row>
            <Label for="postal_code_filter" sm={4}>Postal Code:</Label>
            <Col sm={6}>
              <PostalCodeInput id="postal_code_filter" name="postalCode"
                placeholder="Enter a postal code"
                innerName="postalCodeId" />
            </Col>
          </FormGroup>
        </Col>
      </Row>

      <InlineFeedback invalid={invalid} className="mt-0 mb-2">
        Please enter data into at least one field.
      </InlineFeedback>

      <Row className="pt-2">
        <Col className="oms-row">
          <BusyButton type="submit" color="primary" className="action-link"
            value="Search" busy={busy} >
            <SearchIcon />
          </BusyButton>

          <Button type="reset" color="secondary" disabled={busy} className="action-link">
            <RefreshIcon /> Reset
          </Button>
        </Col>
      </Row>

      {busy && <SpinnerOverlay />}
    </Form>
  );
}
